import {MinusCircleOutlined, PlusOutlined} from '@ant-design/icons';
import {Button, Col, Form, InputNumber, Row, Select} from 'antd';
import styles from '../../subscriptionSettings.module.scss';
import CatalogModalSection from './CatalogModalSection';

const CatalogPricingSection = ({currencyOptions, discountTypes}) => {
  const buildNewPrice = () => ({
    currency: currencyOptions[0]?.value || 'USD',
    amount: 0,
    discountType: 'NONE',
    discountValue: null,
  });

  return (
    <CatalogModalSection
      title="Pricing"
      description="Each price row can define its own discount.">
      <Form.List name="prices">
        {(fields, {add, remove}) => (
          <div className={styles['catalog-price-list']}>
            <div className={styles['catalog-price-list-header']}>
              <span>Prices</span>
              <Button
                type="dashed"
                icon={<PlusOutlined />}
                onClick={() => add(buildNewPrice())}>
                Add price
              </Button>
            </div>

            {fields.map((field, index) => (
              <div key={field.key} className={styles['catalog-price-row']}>
                <Row gutter={12} align="middle">
                  <Col span={6}>
                    <Form.Item
                      label="Currency"
                      name={[field.name, 'currency']}
                      rules={[{required: true, message: 'Currency required'}]}>
                      <Select
                        showSearch
                        optionFilterProp="label"
                        options={currencyOptions}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={5}>
                    <Form.Item
                      label="Amount"
                      name={[field.name, 'amount']}
                      rules={[{required: true, message: 'Amount required'}]}>
                      <InputNumber
                        className="input-number"
                        min={0}
                        style={{width: '100%'}}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label="Discount type"
                      name={[field.name, 'discountType']}
                      rules={[
                        {required: true, message: 'Discount type required'},
                      ]}>
                      <Select options={discountTypes} />
                    </Form.Item>
                  </Col>
                  <Col span={5}>
                    <Form.Item shouldUpdate noStyle>
                      {({getFieldValue}) => {
                        const rowType = getFieldValue([
                          'prices',
                          field.name,
                          'discountType',
                        ]);
                        const isPercentage = rowType === 'PERCENTAGE';

                        return (
                          <Form.Item
                            label={
                              isPercentage ? 'Discount (%)' : 'Discount amount'
                            }
                            name={[field.name, 'discountValue']}
                            rules={
                              rowType && rowType !== 'NONE'
                                ? isPercentage
                                  ? [
                                      {
                                        required: true,
                                        message: 'Discount value required',
                                      },
                                      {
                                        type: 'number',
                                        min: 0,
                                        max: 100,
                                        message: 'Use 0-100',
                                      },
                                    ]
                                  : [
                                      {
                                        required: true,
                                        message: 'Discount value required',
                                      },
                                    ]
                                : []
                            }>
                            <InputNumber
                              className="input-number"
                              min={0}
                              placeholder={
                                isPercentage ? 'e.g. 10' : 'e.g. 5.00'
                              }
                              disabled={!rowType || rowType === 'NONE'}
                              style={{width: '100%'}}
                            />
                          </Form.Item>
                        );
                      }}
                    </Form.Item>
                  </Col>
                  <Col span={2}>
                    <Form.Item label={index === 0 ? ' ' : ' '}>
                      <Button
                        type="text"
                        danger
                        icon={<MinusCircleOutlined />}
                        disabled={fields.length <= 1}
                        onClick={() => remove(field.name)}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </div>
            ))}
          </div>
        )}
      </Form.List>
    </CatalogModalSection>
  );
};

export default CatalogPricingSection;
